// src/components/FloatingSponsor.js
import React from "react";

export default function FloatingSponsor({ lang = "en" }) {
  const text =
    lang === "ar"
      ? "مملوك ومدعوم من مجموعة عوض للاستثمار"
      : "Owned & Supported by Awad Investment Group";

  return (
    <>
      <a
        href="https://awad-investment-group.example" // <- replace with your URL or mailto
        target="_blank"
        rel="noopener noreferrer"
        aria-label={text}
        style={{
          position: "fixed",
          // Keep clear of your AI button (which sits at bottom:18,right:18)
          bottom: 92,           // ~18 + 74px so they don't overlap
          right: 18,
          background: "rgba(255,255,255,0.85)",
          padding: "6px 10px",
          borderRadius: 20,
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          display: "flex",
          alignItems: "center",
          gap: 8,
          textDecoration: "none",
          zIndex: 1000,
          backdropFilter: "saturate(120%) blur(6px)",
          WebkitBackdropFilter: "saturate(120%) blur(6px)",
          color: "#333",
          fontSize: 12,
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/awad-logo.png`}
          alt=""
          aria-hidden="true"
          style={{ height: 22, width: "auto", display: "block" }}
        />
        <span>{text}</span>
      </a>

      {/* Responsive tweak: on small screens move to bottom-left to avoid chat & nav overlap */}
      <style>{`
        @media (max-width: 640px) {
          a[aria-label="${text.replace(/"/g, '\\"')}"] {
            right: auto !important;
            left: 12px !important;
            bottom: 12px !important;
          }
        }
      `}</style>
    </>
  );
}
